import { BP_MOBILE_CHAT } from '@/globals';

// https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
export function isTouchDevice() {
    // @ts-ignore
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

export function isMobileWidth() {
    return window.innerWidth <= BP_MOBILE_CHAT;
}

export function isSmallMobileWidth() {
    return window.innerWidth <= 767;
}

export function getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
    const MOBILE_MAX_WIDTH = 767;
    const TABLET_MAX_WIDTH = 1024;

    const ua = navigator.userAgent || navigator.vendor || '';

    // Modern iPad detection (iPadOS 13+ reports as Mac)
    if (/Macintosh/.test(ua) && isTouchDevice()) {
        return 'tablet';
    }

    // Explicit device detection
    if (/iPhone|iPod/.test(ua)) return 'mobile';
    if (/iPad/.test(ua)) return 'tablet';
    if (/Android/.test(ua)) {
        return /mobile/i.test(ua) ? 'mobile' : 'tablet';
    }
    if (/Windows Phone|BlackBerry|webOS/.test(ua)) return 'mobile';
    if (/Kindle|Silk|PlayBook/.test(ua)) return 'tablet';

    // Fallback: use touch + screen size
    if (isTouchDevice()) {
        const smallestDimension = Math.min(window.innerWidth, window.innerHeight);
        if (smallestDimension <= MOBILE_MAX_WIDTH) return 'mobile';
        if (smallestDimension <= TABLET_MAX_WIDTH) return 'tablet';
    }

    return 'desktop';
}
